import {
  SchemasApi,
  OrganisationsApi,
  SitesApi,
  DataApi,
  MetersApi,
} from "@solarschools/api-sdk-typescript";

export default class ApiManager {
  constructor(apiBaseUri, user = null, refreshUri = null) {
    this.user = user || null;
    this.apiBaseUri = apiBaseUri;
    this.refreshUri = refreshUri;
    this.cache = {};
    this.refreshPromise = null;
  }

  validToken() {
    return !!(this.user && this.refreshUri);
  }

  async refresh() {
    if (!this.validToken()) {
      return;
    }
    if (this.refreshPromise) {
      await this.refreshPromise;
    } else {
      this.refreshPromise = new Promise(async (resolve, reject) => {
        this.cache = {};
        try {
          const response = await fetch(this.refreshUri);
          this.user = await response.json();
        } catch(e) {
          console.warn(e);
          this.user = null;
        }
        resolve();
      });

      await this.refreshPromise;
      this.refreshPromise = null;
    }
  }

  getConfig() {
    const { accessToken = null } = this.user || {};
    const config = {
      basePath: this.apiBaseUri,
    };

    if (accessToken) {
      config.baseOptions = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
    }

    return config;
  }

  async client(apiService) {
    if (this.refreshPromise) {
      await this.refreshPromise;
    }

    const apiServiceLower = apiService.toLowerCase();

    if (!this.cache[apiServiceLower]) {
      this.cache[apiService] = this.initClient(apiServiceLower);
    }

    return this.cache[apiServiceLower];
  }

  initClient(apiService) {
    const config = this.getConfig();
    switch (apiService) {
      case "schemas":
      case "schema":
        return new SchemasApi(config);
      case "organisations":
      case "organisation":
        return new OrganisationsApi(config);
      case "sites":
      case "site":
        return new SitesApi(config);
      case "data":
        return new DataApi(config);
      case "meters":
        return new MetersApi(config);
      default:
        throw new Error(`Invalid API service: ${resourceType}.`);
    }
  }

  async call(apiService, method, parameters = [], attempt = 1) {
    const client = await this.client(apiService);

    try {
      const { data } = await client[method].apply(client, parameters);
      return data;
    } catch(e) {
      if (attempt > 1 || !this.validToken()) {
        throw e;
      }
      console.warn(e, 'attempt:', attempt);
      await this.refresh();
      return this.call(apiService, method, parameters, attempt + 1);
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/ApiManager/index.js